/* eslint-disable */
import axios from 'axios'
import { sanitize } from '@/js/utils/sanitize'
import { randomBaseUrl } from '@/js/utils/randomBaseUrl'

export const getQuestions = params => new Promise ((resolve, reject) => {

  // const keyword = params.keyword ? encodeURIComponent(params.keyword) : undefined
  let keywords = params.keywords ? sanitize(params.keywords) : undefined
  let lang = params.lang ? sanitize(params.lang) : 'en'
  let page = params.page ? sanitize(params.page) : undefined
  let search = params.search ? sanitize(params.search) : undefined
  let key = sanitize(params.key)

  keywords = keywords ? encodeURIComponent(keywords) : undefined
  lang = lang ? encodeURIComponent(lang) : 'en'
  page = page ? encodeURIComponent(page) : undefined
  search = search ? encodeURIComponent(search) : undefined
  key = encodeURIComponent(key)

  const questionType = params.questionType ? sanitize(params.questionType) : 'all'

  let uri = '?options=linefeed'
  // uri = keyword &&
  //       keyword !== undefined &&
  //       keyword !== 'undefined' ? `${uri}&keyword=${keyword}` : uri
  uri = keywords &&
        keywords !== undefined &&
        keywords !== 'undefined' ? `${uri}&keywords=${keywords}` : uri
  uri = lang &&
        lang !== undefined &&
        lang !== 'undefined' ? `${uri}&lang=${lang}` : `${uri}&lang=en`
  uri = page &&
        page !== undefined &&
        page !== 'undefined' ? `${uri}&page=${page}` : uri
  uri = search &&
        search !== undefined &&
        search !== 'undefined' ? `${uri}&search=${search}` : uri
  uri = `${uri}&valid=${key}`

  axios.get(randomBaseUrl(0, 3) + process.env.VUE_APP_GET_QUESTIONS_ENDPOINT + uri)
    .then(response => {
      const status = response.data.status
      const questions = response.data.answer

      if (status === 'ok') {

        if (questionType === 'all') {
          // console.log('all : ' + questions.public)
          resolve(questions)

        } else if (questionType === 'pending') {
          // console.log('pending : ' + questions.pending)
          resolve(questions.pending)

        } else if (questionType === 'private') {
          // console.log('private : ' + questions.private)
          resolve(questions.private)

        } else if (questionType === 'public') {
          // console.log('public : ' + questions.public)
          resolve(questions.public)

        } else if (questionType === 'pending+private' || questionType === 'private+pending') {
          let data = [...questions.private, ...questions.pending]
          resolve(data)

        } else if (questionType === 'pending+public' || questionType === 'public+pending') {
          let data = [...questions.public, ...questions.pending]
          resolve(data)

        } else if (questionType === 'private+public' || questionType === 'public+private') {
          let data = [...questions.public, ...questions.private]
          resolve(data)

        } else {
          // console.log('else : ' + questions.public)
          resolve(questions.public)
        }
      }
    })
    .catch(error => {
      reject(error)
    })
})
